import Column from '@components/Column';
import Row from '@components/Row';
import Skeleton from '@components/Skeleton';
import { css } from '@emotion/react';

function ItemFooterSkeleton() {
    return (
        <Column fullWidth spacing={5}>
            <Row fullWidth justify='space-between'>
                <Skeleton width={120} height={22} />
                <Skeleton width={82} height={30}/>
            </Row>
            <Row fullWidth spacing={2}>
                <Skeleton width={0} height={56} css={css`flex: 1`} shape='block'/>
                <Skeleton width={0} height={56} css={css`flex: 1`} shape='block' />
            </Row>
        </Column>
    );
}

export default ItemFooterSkeleton;
